export type Theme = 'dark' | 'light'

export const THEME_STORAGE_KEY = 'sbt-theme'
export const THEME_CHANGE_EVENT = 'sbt-theme-change'

export function resolveInitialTheme(storedTheme: string | null): Theme {
  if (storedTheme === 'dark' || storedTheme === 'light') return storedTheme
  return 'dark'
}

export function currentTheme(): Theme {
  if (typeof document === 'undefined') return 'dark'
  return document.documentElement.dataset.theme === 'light' ? 'light' : 'dark'
}

export function applyTheme(theme: Theme, persist = true) {
  if (typeof document === 'undefined') return

  document.documentElement.dataset.theme = theme
  document.documentElement.style.colorScheme = theme

  const themeColor = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')
  themeColor?.setAttribute('content', theme === 'light' ? '#f4f5f7' : '#131313')

  if (persist) {
    try {
      window.localStorage.setItem(THEME_STORAGE_KEY, theme)
    } catch {
      // Storage can be unavailable in privacy-restricted browsing contexts.
    }
  }

  window.dispatchEvent(new CustomEvent(THEME_CHANGE_EVENT, {
    detail: { theme },
  }))
}

export function toggleTheme() {
  applyTheme(currentTheme() === 'dark' ? 'light' : 'dark')
}
